<div class="confirm-dialog">
  <h2 mat-dialog-title>
    <mat-icon [style.color]="getIconColor()">{{ data.icon }}</mat-icon>
    {{ data.title }}
  </h2>

  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ data.cancelText }}
    </button>

    <button
      *ngIf="data.showSaveButton"
      mat-raised-button
      color="accent"
      (click)="onSave()">
      <mat-icon>save</mat-icon>
      {{ data.saveText }}
    </button>

    <button
      mat-raised-button
      [color]="data.confirmColor"
      (click)="onConfirm()">
      <mat-icon>check</mat-icon>
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
